import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocale } from '../../hooks';
import { FieldType, FilterConditionOperator } from '../../types';
import { DropdownSelect } from '../DropdownSelect';
/**
 * A component that renders a select dropdown for selecting a filter condition operator.
 */
export const FilterConditionOpPicker = (props) => {
    const { t } = useLocale();
    const [options, setOptions] = useState([]);
    /**
     * Event handler for the select dropdown change event.
     * @param event - The select change event.
     */
    const handleOnChange = (event) => {
        props.onChange(event.target.value ?? '');
    };
    useEffect(() => {
        const opts = [];
        if (props.field.selections || props.field.isLookup) {
            opts.push({
                value: FilterConditionOperator.IN,
                label: t('filter.condition.operator.in'),
            });
        }
        else {
            if (props.field.type === FieldType.STRING) {
                opts.push({
                    value: FilterConditionOperator.EQUALS,
                    label: t('filter.condition.operator.equals'),
                });
                opts.push({
                    value: FilterConditionOperator.CONTAINS,
                    label: t('filter.condition.operator.contains'),
                });
                opts.push({
                    value: FilterConditionOperator.STARTS_WITH,
                    label: t('filter.condition.operator.starts_with'),
                });
                opts.push({
                    value: FilterConditionOperator.ENDS_WITH,
                    label: t('filter.condition.operator.ends_with'),
                });
                opts.push({
                    value: FilterConditionOperator.MATCH_REGEX,
                    label: t('filter.condition.operator.match_regex'),
                });
            }
            if (props.field.type === FieldType.BOOLEAN) {
                opts.push({
                    value: FilterConditionOperator.EQUALS,
                    label: t('filter.condition.operator.equals'),
                });
            }
            if (props.field.type === FieldType.INTEGER ||
                props.field.type === FieldType.DECIMAL ||
                props.field.type === FieldType.DATE ||
                props.field.type === FieldType.DATE_TIME) {
                opts.push({
                    value: FilterConditionOperator.EQUALS,
                    label: t('filter.condition.operator.equals'),
                    displayText: '=',
                });
                opts.push({
                    value: FilterConditionOperator.GREATER_THAN,
                    label: t('filter.condition.operator.greater_than'),
                    displayText: '>',
                });
                opts.push({
                    value: FilterConditionOperator.GREATER_THAN_OR_EQUAL,
                    label: t('filter.condition.operator.greater_than_or_equal'),
                    displayText: _jsx(_Fragment, { children: "\u2265" }),
                });
                opts.push({
                    value: FilterConditionOperator.LESS_THAN,
                    label: t('filter.condition.operator.less_than'),
                    displayText: '<',
                });
                opts.push({
                    value: FilterConditionOperator.LESS_THAN_OR_EQUAL,
                    label: t('filter.condition.operator.less_than_or_equal'),
                    displayText: _jsx(_Fragment, { children: "\u2264" }),
                });
            }
        }
        setOptions(opts);
        if (!props.value) {
            props.onChange(opts[0].value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.field]);
    return (_jsx(DropdownSelect, { label: '', value: props.value, onChange: handleOnChange, options: options, className: props.className, disabled: props.readonly, color: 'primary' }));
};
